/* creditCosts.js — the "About N credits" estimates shown on each tool's run button.
 *
 * ESTIMATES, not promises: a run is charged by what it really cost (1 credit =
 * 3c of Claude spend, rounded up), so the label says "About". They are the
 * measured-pattern figures from engineering/billing/JAI_CREDITS_SPEC.md and
 * stay until the AiUsage table has real per-route averages (then replace
 * these with the measured numbers).
 *
 * Keys are feature names, not routes, so a route rename does not touch this.
 */
export const CREDIT_COST = {
  // 1 credit
  askQuick: 1,
  draftChat: 1,
  moves: 1,
  injuryInsurance: 1,
  scheduleSurgeon: 1,
  draftReview: 1,
  // 3 credits
  askLookup: 3,
  playerAnalyser: 3,
  opponentScout: 3,
  // 5 credits
  waiverWire: 5,
  teamAnalyser: 5,
  liveDraftAdvice: 5,
  // 8 credits
  deepResearch: 8,
  tradeAnalyser: 8,
  tradeRadar: 8,
  // about 20
  draftStrategy: 20,
}

/** "About 5 credits" / "About 1 credit". */
export const creditCostLabel = (key) => {
  const n = CREDIT_COST[key]
  if (!n) return ''
  return `About ${n} credit${n === 1 ? '' : 's'}`
}
